import { apiConfig } from 'core-lib/config/config';
import { postMethod } from 'core-lib/utils/apiV2';
import toast from 'react-hot-toast';
import { Balance } from '../types/VRNDetails';

function serialize(data: any) {
  const balanceAmt =
    data?.balance_fetch_data?.balance && data.balance_fetch_data.balance !== ''
      ? data.balance_fetch_data.balance
      : null;
  const balance: ResponseTypes = {
    isDone: !data.is_balance_fetch_pending,
    pollingInterval: data.polling_interval * 1000,
    pollingTimeout: data.polling_timeout * 1000,
    requestId: data.request_id,
    show: balanceAmt ?? false,
    balance: balanceAmt ?? null,
    updatedAt: data?.balance_fetch_data?.balance_updated_at,
    tagStatus: data?.balance_fetch_data?.tag_status ?? '',
    bankPhoneNumber: data?.blacklist_support_number ?? '',
  };
  return balance;
}

interface ResponseTypes extends Balance {
  isDone: boolean;
  requestId: string;
  pollingInterval: number;
  pollingTimeout: number;
}

type ResultTypes = {
  response?: ResponseTypes;
  error?: any;
};

export const fetchBalance = (body: any): Promise<ResultTypes> =>
  new Promise((resolve) => {
    (async function callBalanceApi() {
      const url = `${apiConfig(
        'fastagIssuance'
      )}/fastag-recharge/balance/v1.1/fetch`;
      const { response, error }: any = await postMethod({
        endPoint: url,
        body,
      });
      if (response) {
        if (response?.data) {
          resolve({ response: serialize(response.data) });
        } else resolve({ error: {} });
      }
      if (error) {
        resolve({ error });
        toast.error('Unable to fetch fastag balance at the time');
      }
    })();
  });
